import clsx from 'clsx';
import React from 'react';

import { Button } from '../BaseButton/Button';

type BaseButtonProps = Omit<
  JSX.IntrinsicElements['button'],
  'color' | 'type'
> & {
  inverted?: boolean;
  hoverIcon?: React.ReactNode;
  extraClassNames?: string;
};

export const TextButton = ({
  onClick,
  children,
  inverted,
  disabled,
  icon,
  hoverIcon,
  extraClassNames,
  ...props
}: BaseButtonProps & { icon?: React.ReactNode }): JSX.Element => (
  <Button
    {...props}
    onClick={onClick}
    type="button"
    disabled={disabled}
    cursor={disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
    color={
      inverted
        ? 'text-main hover:text-main-500'
        : 'text-main-500 hover:text-main'
    }
    extraClassNames={clsx(
      'group flex flex-row items-center outline-none',
      extraClassNames
    )}
  >
    {hoverIcon ? (
      <>
        <span className="block group-hover:hidden">{icon}</span>
        <span className="hidden group-hover:block">{hoverIcon}</span>
      </>
    ) : (
      icon
    )}
    {children}
  </Button>
);
